/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentSlot/view.blocks to change it.
import Calendar from 'DesignSystem/Calendar/react'
import Notifications from './Notifications/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function AppointmentSlot({
  children,
  viewPath = "/App/Form/Data/ProvideData/AppointmentSlot",
  focusArea,
  month,
  monthSlots,
  onChange,
  onClickNextMonth,
  onClickPrevMonth,
  parentViewPath,
  value,
  onClickAppointmentTaken,
  onSubmit
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="AppointmentSlot.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-20S8qX': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="AppointmentSlot.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={4}
 marginBottom={0}
 text="What is the best date and time for the appointment?"
/>
</div>
<div
  data-testid="AppointmentSlot.Vertical:1"
  data-view-path={viewPath}
 ref={focusArea}
 className="views-block"
>
<Calendar
  viewPath={`${viewPath}/Calendar`}
 month={month}
 monthSlots={monthSlots}
 onChange={onChange}
 onClickNextMonth={onClickNextMonth}
 onClickPrevMonth={onClickPrevMonth}
 parentViewPath={parentViewPath}
 value={value}
/>
<Notifications
  viewPath={`${viewPath}/Notifications`}
 onClickAppointmentTaken={onClickAppointmentTaken}
 onClickNextMonth={onClickNextMonth}
/>
</div>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}